Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tab = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _airbnbPropTypes = require('airbnb-prop-types');

var _shallowElementEquals = require('shallow-element-equals');

var _shallowElementEquals2 = _interopRequireDefault(_shallowElementEquals);

var _index = require('./index');

var _index2 = _interopRequireDefault(_index);

var _tab = require('../../utils/propTypes/tab');

var _tab2 = _interopRequireDefault(_tab);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)({
  children: _tab2['default'],
  initialValue: _propTypes2['default'].number,
  micro: (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('micro', 'small'),
  // set to true when performing default browser navigation without dynamic tab panel content
  navigationOnly: _propTypes2['default'].bool,

  onPressTab: _propTypes2['default'].func,
  scrollable: _propTypes2['default'].bool,
  small: (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('micro', 'small')
});

var defaultProps = {
  initialValue: 0,
  micro: false,
  navigationOnly: false,
  onPressTab: null,
  scrollable: false,
  small: false
};

/**
 * TabsController is an uncontrolled component for a tab interface.
 * You should use this if you want the tabs to just work out of the box.

 * For the controlled component equivalent, where you have full
 * control over the component state, use Tabs.
 */

var TabsController = function (_React$Component) {
  _inherits(TabsController, _React$Component);

  function TabsController(props) {
    _classCallCheck(this, TabsController);

    var _this = _possibleConstructorReturn(this, (TabsController.__proto__ || Object.getPrototypeOf(TabsController)).call(this, props));

    _this.state = {
      value: props.initialValue < _react2['default'].Children.count(props.children) ? props.initialValue : defaultProps.initialValue
    };

    _this.onPressTab = _this.onPressTab.bind(_this);
    return _this;
  }

  _createClass(TabsController, [{
    key: 'shouldComponentUpdate',
    value: function () {
      function shouldComponentUpdate(nextProps, nextState) {
        var currentTabIndex = this.state.value;
        var nextTabIndex = nextState.value;
        var currentTab = this.props.children[currentTabIndex];
        var nextTab = nextProps.children[nextTabIndex];
        return currentTabIndex !== nextTabIndex || !(0, _shallowElementEquals2['default'])(currentTab.props, nextTab.props);
      }

      return shouldComponentUpdate;
    }()
  }, {
    key: 'onPressTab',
    value: function () {
      function onPressTab(tabIndex, e) {
        this.setState({
          value: tabIndex
        });

        if (this.props.onPressTab) {
          this.props.onPressTab(tabIndex, e);
        }
      }

      return onPressTab;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _index2['default'],
          {
            navigationOnly: this.props.navigationOnly,
            onPressTab: this.onPressTab,
            scrollable: this.props.scrollable,
            value: this.state.value,
            small: this.props.small,
            micro: this.props.micro
          },
          this.props.children
        );
      }

      return render;
    }()
  }]);

  return TabsController;
}(_react2['default'].Component);

TabsController.componentCategory = 'Core';
TabsController.displayName = 'TabsController';
exports['default'] = TabsController;


TabsController.propTypes = propTypes;
TabsController.defaultProps = defaultProps;
TabsController.Tab = _index.Tab;

exports.Tab = _index.Tab;


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/exp/Tabs/TabsController.js
// module id = 416
// module chunks = 923280921217